/**
 * Generates a data-testid attribute value from a label.
 * Converts to lowercase and replaces spaces with hyphens.
 *
 * @example
 * getTestId({ prefix: 'actions-dropdown', label: 'Export Data', suffix: 'btn' })
 * // Returns: 'actions-dropdown-export-data-btn'
 */
export interface GetTestIdOptions {
  prefix?: string;
  label?: string;
  suffix?: string;
}

export const getTestId = ({
  prefix = '',
  label = '',
  suffix = '',
}: GetTestIdOptions): string => {
  const normalizedLabel = label.toLowerCase().replace(/\s+/g, '-');

  return `${prefix}-${normalizedLabel}-${suffix}`;
};
